import styled from 'vue3-styled-components';

export const ProductSelectModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

export const ProductSelectModalContainer = styled.div`
    background: white;
    border-radius: 8px;
    width: 90%;
    max-width: 1000px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const ProductSelectModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #e0e0e0;
`;

export const ProductSelectModalTitle = styled.h2`
    margin: 0;
    font-size: 20px;
    font-weight: 600;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    color: #666;
    
    &:hover {
        color: #333;
    }
`;

export const ProductSelectModalContent = styled.div`
    padding: 20px;
    overflow-y: auto;
    flex: 1;
`;

export const CategorySelectSection = styled.div`
    margin-bottom: 20px;
`;

export const CategorySelectLabel = styled.label`
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 14px;
`;

export const CategorySelect = styled.select`
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    
    &:focus {
        outline: none;
        border-color: #0f4c5c;
    }
`;

export const ProductListSection = styled.div`
    margin-top: 20px;
`;

export const ProductListHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    gap: 16px;
`;

export const LeftSection = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const SearchAndCountWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const SearchInputWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 0;
    overflow: hidden;
    
    &:focus-within {
        border-color: #0f4c5c;
    }
`;

export const SearchInput = styled.input`
    padding: 8px 12px;
    border: none;
    border-radius: 0;
    font-size: 14px;
    width: 200px;
    outline: none;
    
    &::placeholder {
        color: #999;
    }
`;

export const SearchButton = styled.button`
    background: #0f4c5c;
    border: none;
    padding: 8px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    transition: background 0.2s;
    
    &:hover {
        background: #0f4c5c;
    }
    
    &:active {
        background: #0f4c5c;
    }
`;

export const ProductListTitle = styled.h3`
    margin: 0;
    font-size: 18px;
    font-weight: 600;
`;

export const ProductCount = styled.span`
    color: #666;
    font-size: 14px;
`;

export const ProductTable = styled.div`
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    
    /* 테이블 컬럼 너비 정의 (체크박스 제거로 4개 컬럼) */
    --table-columns: 1fr 2fr 100px 120px;
`;

export const ProductTableHeader = styled.div`
    display: grid;
    grid-template-columns: var(--table-columns);
    gap: var(--table-gap);
    padding: 12px;
    background: #f5f5f5;
    font-weight: 600;
    border-bottom: 1px solid #ddd;
    font-size: 14px;
`;

export const ProductTableBody = styled.div`
    max-height: 400px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f5f9;
      border-radius: 10px;
      margin: 4px 0;
    }
    
    &::-webkit-scrollbar-thumb {
      background: linear-gradient(135deg, #cbd5e1, #94a3b8);
      border-radius: 10px;
      border: 2px solid #f1f5f9;
      transition: all 0.2s ease;
      
      &:hover {
        background: linear-gradient(135deg, #94a3b8, #64748b);
        transform: scale(1.05);
      }
      
      &:active {
        background: linear-gradient(135deg, #64748b, #475569);
      }
    }
    
    &::-webkit-scrollbar-corner {
      background: #f1f5f9;
    }
    
    &::-webkit-scrollbar-track-piece {
      background: transparent;
    }
`;

export const ProductTableRow = styled.div`
    display: grid;
    grid-template-columns: var(--table-columns);
    gap: var(--table-gap);
    padding: 12px;
    border-bottom: 1px solid #eee;
    align-items: center;
    font-size: 14px;
    
    &:hover {
        background: #f9f9f9;
    }
    
    &.selected {
        background: #f0f7ff;
    }
    
    input[type="number"] {
        border: 1px solid #ddd;
        border-radius: 4px;
        text-align: center;
    }
`;

export const SelectedProductsSummary = styled.div`
    margin-top: 20px;
    padding: 16px;
    background: #f0f7ff;
    border-radius: 4px;
`;

export const SummaryTitle = styled.div`
    font-weight: 600;
    color: #2563eb;
    font-size: 14px;
`;

export const ProductSelectModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 20px;
    border-top: 1px solid #e0e0e0;
`;

export const ModalButton = styled.button`
    padding: 10px 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    background: ${props => props.primary ? '#2563eb' : 'white'};
    color: ${props => props.primary ? 'white' : '#333'};
    transition: background 0.2s;
    
    &:hover {
        background: ${props => props.primary ? '#1d4ed8' : '#f5f5f5'};
    }
`;

export const LoadingMessage = styled.div`
    text-align: center;
    padding: 40px;
    color: #666;
    font-size: 14px;
`;

export const EmptyMessage = styled.div`
    text-align: center;
    padding: 40px;
    color: #999;
    font-size: 14px;
`;